<rc-scanner (handleQrCodeScanned)="tryHandleQrCodeScanned($event)"></rc-scanner>
